/* Cloudflare Turnstile — explicit rendering for form-builder forms */

// The widget div is emitted by shared/_embedded_form only when the site is
// configured for Turnstile. We render it explicitly (api.js is loaded with
// ?render=explicit) rather than letting Cloudflare auto-scan, because the form
// sits inside a Turbo Frame: on a validation error the frame is swapped and an
// auto-scanned widget would come back inert, leaving the visitor unable to
// resubmit. Rendering on turbo:frame-load also hands back a fresh token, which
// matters because Turnstile tokens are single-use.

const RETRY_MS = 200;
const MAX_WAIT_MS = 15000;

function renderWidget(el) {
  // dataset flag keeps this idempotent — initTurnstile is called from several
  // events and must be a no-op for widgets it has already handled.
  if (el.dataset.wpsTurnstileRendered === 'true') return;
  if (!el.dataset.sitekey) return;

  el.dataset.wpsTurnstileRendered = 'true';
  window.turnstile.render(el, { sitekey: el.dataset.sitekey });
}

export function initTurnstile() {
  const widgets = document.querySelectorAll('[data-wps-turnstile]:not([data-wps-turnstile-rendered="true"])');
  if (widgets.length === 0) return;

  if (window.turnstile) {
    widgets.forEach(renderWidget);
    return;
  }

  // api.js is loaded async/defer alongside the widget, so it may not have
  // arrived yet. Poll briefly rather than wire up an onload callback, which
  // would have to be a global and survive frame swaps.
  let waited = 0;
  const timer = setInterval(() => {
    if (window.turnstile) {
      clearInterval(timer);
      document
        .querySelectorAll('[data-wps-turnstile]:not([data-wps-turnstile-rendered="true"])')
        .forEach(renderWidget);
    } else if ((waited += RETRY_MS) >= MAX_WAIT_MS) {
      clearInterval(timer);
      console.warn('[wps_pages] Cloudflare Turnstile script did not load; the challenge will not render.');
    }
  }, RETRY_MS);
}
